import React, { createContext, useContext, useState, useEffect } from 'react';
import { loginUser, registerUser, getMe, updateProfile as apiUpdateProfile, changePassword as apiChangePassword } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('mrs_token'));

  useEffect(() => {
    if (token) {
      getMe()
        .then(userData => {
          setUser(userData);
          setLoading(false);
        })
        .catch(() => {
          localStorage.removeItem('mrs_token');
          setToken(null);
          setUser(null);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [token]);

  const register = async (userData) => {
    try {
      const res = await registerUser(userData);
      localStorage.setItem('mrs_token', res.token);
      setToken(res.token);
      setUser(res.user);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.detail || 'Registration failed' };
    }
  };

  const login = async (emailOrUsername, password) => {
    try {
      const res = await loginUser({ email: emailOrUsername, password });
      localStorage.setItem('mrs_token', res.token);
      setToken(res.token);
      setUser(res.user);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.detail || 'Invalid credentials' };
    }
  };

  const logout = () => {
    localStorage.removeItem('mrs_token');
    setToken(null);
    setUser(null);
  };

  const updateUserProfile = async (updates) => {
    try {
      const updated = await apiUpdateProfile(updates);
      setUser(updated);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.detail || 'Update failed' };
    }
  };

  const changeUserPassword = async (currentPw, newPw) => {
    try {
      await apiChangePassword({ currentPassword: currentPw, newPassword: newPw });
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.detail || 'Password change failed' };
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, register, login, logout, updateProfile: updateUserProfile, changePassword: changeUserPassword }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};
